import React from "react"
import {useTranslation} from "next-i18next"
import PropTypes from "prop-types"
import {useRouter} from "next/router"
import Typography from "../../reusable/Typography/Typography"
import {ArrowLeft} from "react-bootstrap-icons"

type Props = {
    activeStep: 1 | 2 | 3,
	isNewDesign?: boolean
}

export const StepsIndicatorLine: React.FC<Props> = ({activeStep, isNewDesign}) => {
	const {t} = useTranslation(["checkout", "common"])
	const router = useRouter()
	const title = activeStep === 1 ? t("contact-details") : t("identity-verification")
	const handleArrowClick = () => {
		router.push(t("/checkout"))
	}

	const progressBarWidth = activeStep === 1 ? "50%" : "100%"

	return (
		<>
			{!isNewDesign ? <div className={"row mb-3 mb-md-5 position-relative"}>
				{activeStep === 1 && <>
					<div onClick={handleArrowClick}
						style={{left: -45, top: 1}}
						className="d-md-none col-1 pointer me-2 mt-1">
						<ArrowLeft size={23}/>
					</div>
					<div onClick={handleArrowClick}
						style={{left: -45, top: 1}}
						className="col-1 pointer position-absolute">
						<ArrowLeft size={30}/>
					</div>
				</>
				}
				<div className="col">
					<div className="d-flex justify-content-between">
						<div>
							<Typography variant="heading2"
								semanticTag="span"
								className={"me-3"}>{t("step")}</Typography>
							<Typography variant="heading2"
								semanticTag="span">{activeStep}</Typography>
							<Typography className="text-secondary"
								variant="heading3"
								semanticTag="span">/2</Typography>
						</div>
					</div>
					<div style={{height: 4, backgroundColor: "#DEE2E6"}}
						className={"text-primary rounded  position-relative"}>
						<div className={`position-absolute start-0 top-0 bg-primary rounded h-100 ${activeStep === 1 ? "w-50" : "w-100"}`}></div>
					</div>
				</div>
				<Typography className={"mt-2"}
					variant="heading2"
					semanticTag="h3">{t(title, {ns: "common"})}</Typography>
			</div> :
				<div className={"row mb-3 mb-md-5 position-relative"}>
					<div className="col">
						<div className="d-flex justify-content-between align-items-center mb-2">
							<Typography className={""}
								variant="heading2"
								semanticTag="h3">{t(title, {ns: "common"})}</Typography>
							<div>
								<Typography variant="heading2"
									semanticTag="span">{activeStep}</Typography>
								<Typography className="text-secondary"
									variant="heading3"
									semanticTag="span">/2</Typography>
							</div>
						</div>
						<div style={{height: 4, backgroundColor: "#DEE2E6"}}
							className={"text-primary rounded  position-relative"}>
							<div className="position-absolute start-0 top-0 bg-primary rounded h-100"
								style={{width: `${progressBarWidth}`}}></div>
						</div>
					</div>
				</div>
			}
		</>
	)
}

StepsIndicatorLine.propTypes = {
	activeStep: PropTypes.oneOf([1, 2, 3]),
	isNewDesign: PropTypes.bool
}

